import { render, staticRenderFns } from "./CurrentDate.vue?vue&type=template&id=aafb7a7a&"
import script from "./CurrentDate.vue?vue&type=script&lang=js&"
export * from "./CurrentDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports